import axios from "axios";

const auth = {
  headers: {
    Authorization: "Basic " + btoa(window.env.SECRET_KEY),
  },
};

export const ticketApi = {
  getBranchInfo: async (apiUrl, branchId) => {
    const header = { branchId: branchId };
    try {
      const res = await axios.get(apiUrl + "/api/Info/GetHotel", {
        headers: {
          ...auth.headers,
          ...header,
        },
      });
      return res;
    } catch (error) {}
  },
  getTicketByUrl: async (apiUrl, branchId) => {
    const header = { branchId: branchId };
    try {
      const res = await axios.get(apiUrl + "/api/Info/GetProduct", {
        headers: {
          ...auth.headers,
          ...header,
        },
      });
      return res;
    } catch (error) {}
  },
  getCategory: async (apiUrl, branchId) => {
    const header = { branchId: branchId };
    try {
      const res = await axios.get(apiUrl + "/api/Info/GetCategory", {
        headers: {
          ...auth.headers,
          ...header,
        },
      });
      return res;
    } catch (error) {}
  },
  namABankGenerateQRCode: async (apiUrl, branchId, agencyCode, data) => {
    const header = { branchId: branchId, AgencyCode: agencyCode };
    try {
      const res = await axios.post(
        apiUrl + "/api/Integrate/NamABankGenerateQRCode",
        data,
        {
          headers: {
            ...auth.headers,
            ...header,
          },
        },
      );
      return res;
    } catch (error) {
      return {};
    }
  },
  getSessionStatus: async (apiUrl, branchId, data) => {
    const header = { branchId: branchId };
    try {
      const res = await axios.get(
        apiUrl + `/api/Integrate/GetSessionStatus?sessionId=${data.sessionId}`,
        {
          headers: {
            ...auth.headers,
            ...header,
          },
        },
      );
      return res;
    } catch (error) {}
  },

  getCustomer: async (apiUrl, branchId, id) => {
    const header = { branchId: branchId };
    try {
      const res = await axios.get(apiUrl + `/api/Info/GetCustomer?id=${id}`, {
        headers: {
          ...auth.headers,
          ...header,
        },
      });
      return res;
    } catch (error) {}
  },

  searchBill: async (apiUrl, branchId, data) => {
    const header = { branchId: branchId };
    try {
      const res = await axios.get(
        apiUrl +
          `/api/Integrate/SearchBill?phoneNumber=${data.phone}&billCode=${data.billCode}&cccd=${data.cccd}`,
        {
          headers: {
            ...auth.headers,
            ...header,
          },
        },
      );
      return res;
    } catch (error) {}
  },
  getListBranch: async (apiUrl) => {
    try {
      const res = await axios.get(apiUrl + `/api/Ticket/GetListBranch`, auth);
      return res;
    } catch (error) {}
  },

  loginAgency: async (apiUrl, data) => {
    try {
      const res = await axios.post(
        apiUrl + "/api/Ticket/AuthenAgency",
        data,
        auth,
      );
      return res;
    } catch (error) {
      return {};
    }
  },
  //ADMIN
  loginAdmin: async (apiUrl, data) => {
    try {
      const res = await axios.post(
        apiUrl + "/api/Admin/AuthenAdmin",
        data,
        auth,
      );
      return res;
    } catch (error) {
      return {};
    }
  },
  getListAgency: async (apiUrl) => {
    try {
      const authAdmin = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      };
      const res = await axios.get(
        apiUrl + `/api/Admin/GetListAgency`,
        authAdmin,
      );
      return res;
    } catch (error) {
      return error.response;
    }
  },
  addAgency: async (apiUrl, data) => {
    try {
      const authAdmin = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      };
      const res = await axios.post(
        apiUrl + "/api/Admin/CreateAgency",
        data,
        authAdmin,
      );
      return res;
    } catch (error) {
      return error.response;
    }
  },
  updateAgency: async (apiUrl, data) => {
    try {
      const authAdmin = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      };
      const res = await axios.post(
        apiUrl + "/api/Admin/UpdateAgency",
        data,
        authAdmin,
      );
      return res;
    } catch (error) {
      return error.response;
    }
  },
  lockAgency: async (apiUrl, data) => {
    try {
      const authAdmin = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      };
      const res = await axios.post(
        apiUrl + "/api/Admin/LockAgency",
        data,
        authAdmin,
      );
      return res;
    } catch (error) {
      return error.response;
    }
  },
  updatePasswordAgency: async (apiUrl, data) => {
    try {
      const authAdmin = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      };
      const res = await axios.post(
        apiUrl + "/api/Admin/UpdatePasswordAgency",
        data,
        authAdmin,
      );
      return res;
    } catch (error) {
      return {};
    }
  },
  paymentBill: async (apiUrl, branchId, agencyCode, data) => {
    try {
      const header = { branchId: branchId, AgencyCode: agencyCode };
      const res = await axios.post(apiUrl + "/api/Agency/PaymentGift", data, {
        headers: {
          ...auth.headers,
          ...header,
        },
      });
      return res;
    } catch (error) {
      return {};
    }
  },
};
